import { useSelector } from "react-redux";
import { ContractsOverviewAdmin } from "./ContractsOverviewAdmin";
import { ContractsOverviewCustomer } from "./ContractsOverviewCustomer";

export const ContractsOverview = () => {
    const auth = useSelector((state) => state.app.auth);

    return auth && auth.type === "admin" ? (
        <ContractsOverviewAdmin />
    ) : auth && auth.type === "customer_person" ? (
        <ContractsOverviewCustomer />
    ) : null;
};
